import React from 'react';
import Contact from '../components/sections/Contact';
import styled from 'styled-components';

const ContactPage = () => {
    return (
        <PageContainer>
            <Contact />
        </PageContainer>
    );
};

const PageContainer = styled.div`
  padding-top: 80px; // To account for fixed header
`;

export default ContactPage;
